export const TaskInputTypes = {
  Text: "TEXT",
  Image: "IMAGE",
  Audio: "AUDIO",
  Document: "DOCUMENT",
  Video: "VIDEO",
  ImageCanvas: "IMAGE_CANVAS",
  Csv: "CSV"
};
